import * as React from 'react';
import { FunctionComponent } from 'react';
import { Attachment } from '../../models/generalMessage';
import './CustomNotificationPreviewEmail.css';

interface Props {
  messageEmailSubject: string;
  messageEmailBody: string;
  messageAttachments?: Attachment[];
  showTitle?: boolean;
  senderDisplayName?: string;
}

export const GeneralMessagePreviewEmail: FunctionComponent<Props> = props => {
  const attachments = props.messageAttachments || [];
  const isAttachmentExist = attachments.length > 0;
  const senderDisplayName = props.senderDisplayName || 'Squad In Touch';

  const renderAttachments = (): React.ReactNode => {
    return attachments.map((attachment, index) => (
      <div key={`attachment_${index}`}>
        <a href={attachment.link} target="_blank">
          {attachment.fileName}
        </a>
      </div>
    ));
  };

  return (
    <div className="gmPreviewCard gmPreviewEmail">
      <div className="gmPreviewEmail__head">
        <div className="gmPreviewEmail__from">
          <span className="gmPreviewEmail__avatar">{senderDisplayName.charAt(0).toUpperCase()}</span>
          <span className="gmPreviewEmail__fromLabel">From</span>
          <strong>{senderDisplayName}</strong>
          <span>to selected recipients</span>
        </div>
        <div className="gmPreviewEmail__subject">{props.messageEmailSubject || 'No subject yet'}</div>
      </div>
      <div className="gmPreviewEmail__body">
        {props.messageEmailBody ? (
          <div dangerouslySetInnerHTML={{ __html: props.messageEmailBody }} />
        ) : (
          <span style={{ color: 'var(--text-subtle, #94a3b8)' }}>No email content yet.</span>
        )}
      </div>
      {isAttachmentExist && <div className="gmPreviewEmail__attachments">Attachments: {renderAttachments()}</div>}
    </div>
  );
};
